import API_BASE_URL from "config/api";

const backendUrl = (path) => `${API_BASE_URL}${path}`;

export const linuxDownloads = [
  {
    arch: "amd64",
    label: "Linux amd64",
    filename: "zionladder-linux-amd64.tar.gz",
    descriptionKey: "clients.linux.downloads.amd64",
    downloadUrl: backendUrl("/client-download/linux/amd64/"),
    signedLinkUrl: backendUrl("/client-download/linux/amd64/link/"),
  },
  {
    arch: "arm64",
    label: "Linux arm64",
    filename: "zionladder-linux-arm64.tar.gz",
    descriptionKey: "clients.linux.downloads.arm64",
    downloadUrl: backendUrl("/client-download/linux/arm64/"),
    signedLinkUrl: backendUrl("/client-download/linux/arm64/link/"),
  },
];

export const openWrtSections = [
  {
    packageType: "apk",
    titleKey: "clients.openwrt.sections.apk.title",
    subtitleKey: "clients.openwrt.sections.apk.subtitle",
    groups: [
      {
        titleKey: "clients.openwrt.groups.common",
        targets: [
          ["aarch64_cortex-a53", "aarch64 cortex-a53"],
          ["aarch64_cortex-a72", "aarch64 cortex-a72"],
          ["aarch64_cortex-a76", "aarch64 cortex-a76"],
          ["aarch64_generic", "aarch64 generic"],
          ["x86_64", "x86_64"],
        ],
      },
      {
        titleKey: "clients.openwrt.groups.other",
        targets: [
          ["arm_cortex-a7_neon-vfpv4", "ARM cortex-a7 neon-vfpv4"],
          ["arm_cortex-a8_vfpv3", "ARM cortex-a8 vfpv3"],
          ["arm_cortex-a9", "ARM cortex-a9"],
          ["arm_cortex-a9_neon", "ARM cortex-a9 neon"],
          ["mips_24kc", "MIPS 24kc"],
          ["mipsel_24kc", "MIPSel 24kc"],
          ["mipsel_74kc", "MIPSel 74kc"],
        ],
      },
    ],
  },
  {
    packageType: "ipk",
    titleKey: "clients.openwrt.sections.ipk.title",
    subtitleKey: "clients.openwrt.sections.ipk.subtitle",
    groups: [
      {
        titleKey: "clients.openwrt.groups.common",
        targets: [
          ["aarch64_cortex-a53", "aarch64 cortex-a53"],
          ["aarch64_cortex-a72", "aarch64 cortex-a72"],
          ["aarch64_cortex-a76", "aarch64 cortex-a76"],
          ["aarch64_generic", "aarch64 generic"],
          ["x86_64", "x86_64"],
        ],
      },
      {
        titleKey: "clients.openwrt.groups.other",
        targets: [
          ["arm_cortex-a7_neon-vfpv4", "ARM cortex-a7 neon-vfpv4"],
          ["arm_cortex-a8_vfpv3", "ARM cortex-a8 vfpv3"],
          ["arm_cortex-a9", "ARM cortex-a9"],
          ["arm_cortex-a9_neon", "ARM cortex-a9 neon"],
          ["mips_24kc", "MIPS 24kc"],
          ["mipsel_24kc", "MIPSel 24kc"],
          ["mipsel_74kc", "MIPSel 74kc"],
        ],
      },
    ],
  },
];

export const merlinDownloads = [
  {
    target: "hnd_v8",
    filename: "zionladder-hnd_v8.tar.gz",
    koolshareTarget: "koolshare-hnd_v8",
    koolshareFilename: "koolshare-zionladder-hnd_v8.tar.gz",
    platform: "Broadcom HND 64-bit builds",
    arch: "arm64",
    models:
      "RT-AC86U, GT-AC2900, GT-AC5300, RT-AX88U, RAX80, GT-AX11000, RT-AX92U, RT-AX68U, RT-AX86U, GT-AXE11000, GT-AX6000, ZenWiFi Pro XT12, RT-AX86U PRO, GT-AX11000 PRO, RT-BE86U, RT-BE88U, GT-BE96, RT-BE96U, GT-BE98 PRO",
  },
  {
    target: "hnd",
    filename: "zionladder-hnd.tar.gz",
    koolshareTarget: "koolshare-hnd",
    koolshareFilename: "koolshare-zionladder-hnd.tar.gz",
    platform: "Broadcom HND 32-bit builds",
    arch: "armv7",
    models:
      "TUF-AX3000, TUF-AX3000_V2, TUF-AX5400, RT-AX58U, RT-AX82U, ZenWiFi XT8, ZenWiFi XD4, RT-AX56U, RT-AX1800, RAX50, RAX70",
  },
  {
    target: "mtk",
    filename: "zionladder-mtk.tar.gz",
    koolshareTarget: "koolshare-mtk",
    koolshareFilename: "koolshare-zionladder-mtk.tar.gz",
    platform: "MT798x/MT7988 modified Merlin builds",
    arch: "arm64",
    models: "TX-AX6000, TUF-AX4200Q, GS7, ZenWiFi BT8P",
  },
  {
    target: "ipq64",
    filename: "zionladder-ipq64.tar.gz",
    koolshareTarget: "koolshare-ipq64",
    koolshareFilename: "koolshare-zionladder-ipq64.tar.gz",
    platform: "QCA IPQ 64-bit modified Merlin builds",
    arch: "arm64",
    models: "TUF-BE6500",
  },
  {
    target: "qca",
    filename: "zionladder-qca.tar.gz",
    koolshareTarget: "koolshare-qca",
    koolshareFilename: "koolshare-zionladder-qca.tar.gz",
    platform: "QCA/IPQ807x modified Merlin builds",
    arch: "armv7",
    models: "RT-AX89X",
  },
  {
    target: "arm",
    filename: "zionladder-arm.tar.gz",
    koolshareTarget: "koolshare-arm",
    koolshareFilename: "koolshare-zionladder-arm.tar.gz",
    platform: "Older Merlin arm builds",
    arch: "armv7",
    models: "R6300V2, RT-AC68U, RT-AC88U, RT-AC3100, RT-AC5300",
  },
  {
    target: "ipq32",
    filename: "zionladder-ipq32.tar.gz",
    koolshareTarget: "koolshare-ipq32",
    koolshareFilename: "koolshare-zionladder-ipq32.tar.gz",
    platform: "QCA IPQ 32-bit modified Merlin builds",
    arch: "armv7",
    models: "ZenWiFi BD4",
  },
].map((item) => ({
  ...item,
  downloadUrl: backendUrl(`/client-download/merlin/${item.target}/`),
  signedLinkUrl: backendUrl(`/client-download/merlin/${item.target}/link/`),
  koolshareDownloadUrl: backendUrl(`/client-download/merlin/${item.koolshareTarget}/`),
  koolshareSignedLinkUrl: backendUrl(`/client-download/merlin/${item.koolshareTarget}/link/`),
}));

export const openWrtDownloadUrl = (packageType, target) =>
  backendUrl(`/client-download/openwrt/${packageType}/${target}/`);

export const openWrtSignedLinkUrl = (packageType, target) =>
  backendUrl(`/client-download/openwrt/${packageType}/${target}/link/`);
